import RepaymentRepository from './RepaymentRepository';
import LoanSliderCalculator from './LoanSliderCalculator';

var resizeSensor = require('resize-sensor');

class LoanSlider {
  constructor(config) {

    this.config = config;
    this.amount = config.amount;
    this.defaultAmountIndex = this.getDefaultAmountIndex(config)
    this.repTime = new RepaymentRepository(config.repayment, new URL(window.location.href).searchParams.get('repayment') || config.default.repayment);
    this.calculator = new LoanSliderCalculator();
    this.timeout = null;
    this.root_css = document.querySelector(':root')
  }

  init(elem) {
    this.period = this.repTime.defaultIndex;
    this.rootElem = elem;

    if (!this.rootElem) {
      return;
    }
    this.sliderWrapper = document.querySelector('.loan-slider')
    this.slider = this.rootElem.querySelector('.amount')
    this.sliderTooltip = this.rootElem.querySelector('.slider-tooltip')
    this.sliderTooltipText = this.rootElem.querySelector('.slider-tooltip .slider-tooltip--text')
    this.sliderTooltipArrow = this.rootElem.querySelector('.slider-tooltip--arrow')
    this.sliderLabel = this.rootElem.querySelector('.amount-label');
    this.periodLabel = this.rootElem.querySelector('.period-label');
    this.incPeriodButton = this.rootElem.querySelector('.loan-slider--button.increase')
    this.decPeriodButton = this.rootElem.querySelector('.loan-slider--button.decrease')
    this.monthlyCost = this.rootElem.querySelector('.loan-slider--cost b');
    this.exampleText = this.rootElem.querySelector('.loan-slider--small-text');
    this.link = this.rootElem.querySelector('.loan-link');

    if (this.exampleText) {
      this.exampleTextTemplate = this.exampleText.innerText;
    }

    this.setupInputs()
    this.initListeners()

    this.triggerChange()
  }

  initListeners() {
    this.slider.addEventListener('input', e => {
      e.preventDefault();
      this.renderSelected(e.target);
      this.renderTooltip(e.target);

      this.triggerChange()

    })

    new resizeSensor(this.rootElem, () => {
      this.renderSelected(this.slider);
      this.renderTooltip(this.slider);
    })

    if (this.incPeriodButton) {
      this.incPeriodButton.addEventListener('click', () => {
        if (this.period + 1 < this.repTime.data.length) {
          this.period++;
          this.renderPeriod(this.period)
          this.triggerChange()
        }
      })
    }

    if (this.decPeriodButton) {
      this.decPeriodButton.addEventListener('click', () => {
        if (this.period - 1 >= 0) {
          this.period--;
          this.renderPeriod(this.period)
          this.triggerChange()
        }
      })
    }
  }

  triggerChange() {

    if (this.config.onChange) {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      this.timeout = setTimeout(() => {
        this.config.onChange(this);
      }, 500)
    }
  }

  setupInputs() {
    this.slider.setAttribute('max', this.amount.length - 1)
    this.slider.setAttribute('value', this.defaultAmountIndex);

    this.slider.setAttribute('aria-valuemin', this.amount[0])
    this.slider.setAttribute('aria-valuemax', this.amount[this.amount.length - 1])
    this.slider.setAttribute('aria-valuenow', this.amount[this.amount.length - 1])

    this.renderSelected(this.slider)
    this.renderPeriod(this.period)
    this.renderTooltip(this.slider)
  }

  recalculate() {
    // console.log(this.repTime, this.period);
    this.calculator.calculate(this.amount[this.slider.value], this.repTime.data.length > 0 ? this.repTime.data[this.period].value : null);
    if (this.exampleText || this.monthlyCost) {
      if (this.monthlyCost) {
        this.monthlyCost.innerText = this.formatAmount(this.calculator.monthlyPayment) + '/mån'
      }
      if (this.exampleText) {
        this.renderExampleText({
          amount: this.calculator.amount,
          t: this.repTime.data[this.period].label,
          m: this.calculator.repayment,
          ir: this.calculator.effectiveInterestRate,
          mp: this.calculator.monthlyPayment,
          c: this.calculator.totalCost,
        });
      }
    }
  }

  renderSelected(target) {
    let val = (target.value - target.getAttribute('min')) / (target.getAttribute('max') - target.getAttribute('min'));
    target.style.backgroundImage = '-webkit-gradient(linear, left top, right top, '
      + 'color-stop(' + val + ', #56CCF2), '
      + 'color-stop(' + val + ', #fff)'
      + ')';

    this.sliderLabel.innerText = this.formatAmount(this.amount[target.value]);

    this.slider.setAttribute('aria-valuenow', this.amount[target.value]);

    this.recalculate();
  }

  formatAmount(amount) {
    return amount.toLocaleString('sw-SE') + ' kr' + (amount === this.amount[this.amount.length - 1] ? '+' : '');
  }

  renderPeriod(period) {
    if (this.periodLabel) {
      this.periodLabel.innerText = this.repTime.data[period].label;
    }
    this.recalculate();
  }

  renderTooltip(target) {
    const sliderTooltipWidth = this.sliderTooltip.offsetWidth
    const sliderWrapperWidth = this.sliderWrapper.offsetWidth
    this.sliderTooltipText.innerText = this.formatAmount(this.amount[target.value]);
    let val = (target.value - target.getAttribute('min')) / (target.getAttribute('max') - target.getAttribute('min'));
    let left = (target.offsetWidth * val) - (val * 44) - (sliderTooltipWidth * 0.5 + -22);
    let left_arrow = ((this.slider.offsetWidth - 44) * val) + 15;


    // console.log(this.sliderTooltip);

    this.sliderTooltipArrow.style.left = left_arrow + 'px';
    if (sliderTooltipWidth + left + 40 > sliderWrapperWidth) {
      this.sliderTooltip.style.left = 'unset';
      this.sliderTooltip.style.right = 0;
    } else if (left < 0) {
      this.sliderTooltip.style.right = 'unset';
      this.sliderTooltip.style.left = 0;
    } else {
      this.sliderTooltip.style.right = 'unset';
      this.sliderTooltip.style.left = left + 'px';
    }


    //console.log(sliderTooltipWidth, left, sliderTooltipWidth + left, sliderWrapperWidth);
  }

  renderExampleText(data) {
    if (this.exampleTextTemplate) {
      this.exampleText.innerText = this.exampleTextTemplate.replace(
        /\${(\S+)}/g,
        function (m, key) {
          return data.hasOwnProperty(key) ? data[key].toLocaleString('sw-SE') : '';
        }
      )
    }
  }

  getDefaultAmountIndex(config) {
    let GET = parseInt(new URL(window.location.href).searchParams.get('amount'));
    GET = config.amount.includes(GET) ? GET : null;
    return config.amount.findIndex(x => x === (GET ? GET : config.default.amount));
  }
}

export default LoanSlider;



// WEBPACK FOOTER //
// ./scripts/libs/LoanSlider.js